module.exports = __webpack_public_path__ + "img/stahnout.90f5d04f.svg";